import { QueryResult, useQuery } from '@apollo/client'
import {
  CompanyManagerDashboardAppraisalMeetingStatusQuery,
  CompanyManagerDashboardAppraisalMeetingStatusQueryVariables,
  CompanyManagerDashboardAsYearQuery,
  CompanyManagerDashboardAsYearQueryVariables,
  Country,
  RoleName,
} from '../../../types'
import { COMPANY_MANAGER_DASHBOARD_APPRAISAL_MEETING_STATUS, COMPANY_MANAGER_DASHBOARD_AS_YEAR } from '../appraisal-meeting-status/Queries'

const appraisalMeetingStatusDashboardQueryOptions = {
  fetchPolicy: 'network-only' as const,
}

export const useCompanyManagerDashboardAppraisalMeetingStatus = (
  companyId: string,
  userDashboardRoles: RoleName[],
): QueryResult<CompanyManagerDashboardAppraisalMeetingStatusQuery, CompanyManagerDashboardAppraisalMeetingStatusQueryVariables> => {
  return useQuery<CompanyManagerDashboardAppraisalMeetingStatusQuery, CompanyManagerDashboardAppraisalMeetingStatusQueryVariables>(
    COMPANY_MANAGER_DASHBOARD_APPRAISAL_MEETING_STATUS,
    {
      variables: { companyId, userDashboardRoles },
      ...appraisalMeetingStatusDashboardQueryOptions,
    },
  )
}

export const useCompanyManagerDashboardAppraisalSeasonYear = (
  companyId: string,
  userDashboardRoles: RoleName[],
): QueryResult<CompanyManagerDashboardAsYearQuery, CompanyManagerDashboardAsYearQueryVariables> => {
  return useQuery<CompanyManagerDashboardAsYearQuery, CompanyManagerDashboardAsYearQueryVariables>(COMPANY_MANAGER_DASHBOARD_AS_YEAR, {
    variables: { companyId, country: Country.All, userDashboardRoles },
    fetchPolicy: 'cache-first',
  })
}
